import { useTranslation } from "react-i18next";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import React, { useState } from "react";
import { PackingListFilters } from "../features/PackingListFilters";
import { PackingList } from "../features/PackingList";
import { PackingListExportButton } from "../features/PackingListExportButton";
import { PackingListCompact } from "../features/PackingListCompact";
import { ViewMode, ViewModeToggle } from "../commons/ViewModeToggle";
import { useLocation, useNavigate } from "react-router-dom";

export const PackingListPage = () => {
  const { t } = useTranslation("common");
  const title = t("Packing list");
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.auth.user);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const viewModeParam = queryParams.get("viewMode") as ViewMode | null;
  const isValidViewMode =
    viewModeParam === "compact" || viewModeParam === "complete";

  const [viewMode, setViewMode] = useState<ViewMode>(
    isValidViewMode ? viewModeParam : "compact",
  );

  const handleViewModeChange = (mode: ViewMode) => {
    const params = new URLSearchParams(location.search);
    params.set("viewMode", mode);
    navigate({ search: params.toString() }, { replace: true });
    setViewMode(mode);
  };

  if (!currentUser || currentUser.role === "dealer-employee") {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>

          <ViewModeToggle value={viewMode} onChange={handleViewModeChange} />

          <LayoutHeaderActions>
            <div className="d-flex gap-2">
              <PackingListExportButton />
            </div>
          </LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />

          <PackingListFilters />
        </Content>
      </LayoutContent>

      <div className={"layout-content"}>
        {viewMode === "complete" ? <PackingList /> : <PackingListCompact />}
      </div>
    </Layout>
  );
};
